import React from "react";
import { Table, Tag, Button } from "antd";
import { useNavigate } from "react-router-dom";

const statusColors = {
  "Pending App": { color: "#612EFA", background: "#EEF1F4" },
  "L1 App": { color: "#05622C", background: "#A9FFCD" },
  "Rejected": { color: "#F3060A", background: "#F8E2E2" },
  "In Review": { color: "#1475DD", background: "#ECF7FF" },
  "Approved": { color: "#05622C", background: "#A9FFCD" },
  "Completed": { color: "#05622C", background: "#A9FFCD" },
  "Archieved": { color: "#7B7B7B", background: "#DCDFE1" },
};

const data = [
  {
    key: "01",
    sno: "01",
    fileid: "KTKKAR0825",
    monthname: "JAN 2025",
    tldpe: "140000",
    thdpe:"140000",
    submittedby: "User Name",
    dt: "08:00 | 19-05",
    status: "Pending App",
  },
  {
    key: "02",
    sno: "02",
    fileid: "KTKKAR0825",
    monthname: "FEB 2025",
    tldpe: "140000",
    thdpe:"140000",
    submittedby: "User Name",
    dt: "08:00 | 19-05",
    status: "L1 App",
  },
  {
    key: "03",
    sno: "03",
    fileid: "KTKKAR0825",
    monthname: "MAR 2025",
    tldpe: "140000",
    thdpe:"140000",
    submittedby: "User Name",
    dt: "08:00 | 19-05",
    status: "Rejected",
  },
  {
    key: "04",
    sno: "04",
    fileid: "KTKKAR0825",
    monthname: "APR 2025",
    tldpe: "140000",
    thdpe:"140000",
    submittedby: "User Name",
    dt: "08:00 | 19-05",
    status: "In Review",
  },
  {
    key: "05",
    sno: "05",
    fileid: "KTKKAR0825",
    monthname: "MAY 2025",
    tldpe: "140000",
    thdpe:"140000",
    submittedby: "User Name",
    dt: "08:00 | 19-05",
    status: "Approved",
  },
  {
    key: "06",
    sno: "06",
    fileid: "KTKKAR0825",
    monthname: "JUN 2025",
    tldpe: "140000",
    thdpe:"140000",
    submittedby: "User Name",
    dt: "08:00 | 19-05",
    status: "Completed",
  },
  {
    key: "07",
    sno: "07",
    fileid: "KTKKAR0825",
    monthname: "AUG 2025",
    tldpe: "140000",
    thdpe:"140000",
    submittedby: "User Name",
    dt: "08:00 | 19-05",
    status: "Archieved",
  },
];

const PM_App = () => {
  const navigate = useNavigate(); 

  const columns = [
    { title: "S.no", dataIndex: "sno", key: "sno" },
    { title: "File ID", dataIndex: "fileid", key: "fileid" },
    { title: "Month Name", dataIndex: "monthname", key: "monthname" },
    { title: "T.LDPE", dataIndex: "tldpe", key: "tldpe" },
    { title: "T.HDPE", dataIndex: "thdpe", key: "thdpe" },
    { title: "Submitted By", dataIndex: "submittedby", key: "submittedby" },
    { title: "DT", dataIndex: "dt", key: "dt" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        const style = statusColors[status] || { color: "#000", background: "#f5f5f5" };
        return (
          <Tag
            style={{
              color: style.color,
              background: style.background,
              border: "none",
              borderRadius: "6px",
              padding: "0 12px",
              fontWeight: 500,
              fontSize: 14,
            }}
          >
            {status}
          </Tag>
        );
      },
    },
    {
     title: "Action",
     key: "action",
     render: (_, record) => {
       const isPending = record.status === "Pending App";
       return (
         <Button
           style={{
             border: "1px solid #DCDFE1",
             background: isPending ? "#F7F7F7" : "#E0E0E0", // lighter when disabled
             color: "#3C3C3C",
             borderRadius: "6px",
             cursor: isPending ? "pointer" : "not-allowed",
           }}
           size="small"
           disabled={!isPending}  
           onClick={() => {
             if (isPending) {
               navigate("/approvalscreens/pm-report");
             }
           }}
         >
           VIEW
         </Button>
       );
     },
   }
     ];
  return (
    <div style={{ background: "#F5F7FB", padding: 24 }}>
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        bordered={false}
        style={{ background: "#fff", borderRadius: "10px" }}
      />
    </div>
  );
};

export default PM_App;
